import { render, staticRenderFns } from "./a2p-campaign-review-dialog.vue?vue&type=template&id=d02843c6"
import script from "./a2p-campaign-review-dialog.vue?vue&type=script&lang=js"
export * from "./a2p-campaign-review-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports